const selectors = {
    requestInvoiceCheckBox: '#custom_request_invoice',
    controlsContainer: '#custom_additional_fields_container',
    invoiceTypeSelect: '#custom_invoice_type',
    vatNumberText: '#custom_vat_number_container',
    taxIDText: '#custom_tax_id_container',
    sdiText: '#custom_sdi_number_container'
    /*,
    customFreeShipping: '#custom_free_shipping'
    */
}

document.querySelectorAll(selectors.requestInvoiceCheckBox).forEach((checkBox) => {
    checkBox.addEventListener('change', (event) => {
        cartCustomAttributesUpdateVisibility();
    });
    cartCustomAttributesUpdateVisibility();
});


document.querySelectorAll(selectors.invoiceTypeSelect).forEach((selector) => {
    selector.addEventListener('change', (event) => {
        cartCustomAttributesUpdateVisibility();
    });
})


function cartCustomAttributesUpdateVisibility() {

    checkBox = document.querySelector(selectors.requestInvoiceCheckBox);
    controlsContainer = document.querySelector(selectors.controlsContainer);
    invoiceTypeSelect = document.querySelector(selectors.invoiceTypeSelect);
    vatNumberText = document.querySelector(selectors.vatNumberText);
    taxIDText = document.querySelector(selectors.taxIDText);
    sdiText = document.querySelector(selectors.sdiText);

    if (checkBox.checked) {
        controlsContainer.style.display = "flex";
    } else {
        controlsContainer.style.display = "none";
    }

    if (invoiceTypeSelect.value == "Privato") {
        
        vatNumberText.value = ""
        sdiText.value = ""
        
        vatNumberText.style.display = "none"
        sdiText.style.display = "none"
        taxIDText.style.display = "flex"

    } else if (invoiceTypeSelect.value == "Azienda") {
        
        vatNumberText.value = ""
        sdiText.value = ""

        vatNumberText.style.display = "flex"
        sdiText.style.display = "flex"
        taxIDText.style.display = "flex"

    }
}

/*
subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  
  freeShippingBanner = document.querySelector(selectors.customFreeShipping);

  if (event.cartData.total_price > 14000) {
    freeShippingBanner.classList.add("above_threshold");
  } else {
    freeShippingBanner.classList.remove("above_threshold");
  }

})
*/